import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import { AuthenticationService } from "../../../../auth/service";
import { RefundsService } from "../../../../auth/service/refunds.service";
import { IRefund } from "app/auth/models/refunds";
import { ICurrentUser } from "app/auth/models/user-interface";

@Component({
  selector: "app-my-refunds",
  templateUrl: "./my-refunds.component.html",
  styleUrls: ["./my-refunds.component.scss"]
})
export class MyRefundsComponent implements OnInit {
  @Output() callbackFn: EventEmitter<any> = new EventEmitter();
  public refund_list: IRefund[] = [];
  public me: ICurrentUser;
  showModal: boolean = false;

  constructor(
    public _refundService: RefundsService,
    public _authenticationService: AuthenticationService
  ) {
    this.me = this._authenticationService.getCurrentUser();
  }

  async ngOnInit() {
    await this.loadRefunds();
    this.refund_list = this.refund_list.slice(0, 5);
  }

  async loadRefunds() {
    const translationLabel: string[] = ["PENDING", "APPROVED_FEMALE_SINGULAR", "NOT_APPROVED_SINGULAR", "DELETED"];
    this.refund_list = await this._refundService.getMineRefund().then((refunds: IRefund[]) =>
      refunds
        .map((item: IRefund) => {
          item.enabled_label = translationLabel[item.status];
          return item;
        })
        .sort((a, b) => {
          let dateA = a.date;
          let dateB = b.date;
          return dateA > dateB ? -1 : dateA < dateB ? 1 : 0;
        })
        .slice(0, 5)
    );
  }
}
